import { Col, Divider, Row } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { cooperplaceApi } from 'services/api';
import { Link, Text, SwitchOption } from 'v3/components';
import { DefaultLoadingBodyComponent } from 'v3/components/Card';
import Pagination from 'v3/components/DataTable/Pagination';
import { useSnackbar } from 'v3/components/Snackbar';
import { useFleetManagement } from '../../shared';
import { DestinationContainer } from './styles';

function AttendedLoads() {
  const {
    selected,
    attendedSuggestion,
    setAttendedSuggestion,
    switchTrackerAttended,
    setSwitchTrackerAttended,
    suggestionAdvencedFilters
  } = useFleetManagement();

  const [fetchOptions, setFetchOptions] = useState({
    page: 1,
    perPage: 5,
    total: 0,
    lastPage: 0,
  });
  const [isFetching, setIsFetching] = useState(false);

  const snackbar = useSnackbar();
  const paginationRef = useRef(null);


  const Switch = () => {
    return (
      <SwitchOption
        inactiveText={'Pré Carga'}
        activeText={'Carga'}
        className="mt-1"
        style={{ marginBottom: -15 }}
        activeColor={'#494950'}
        inactiveColor={'#494950'}
        value={!switchTrackerAttended}
        onClick={() => {
          setSwitchTrackerAttended(old => !old);
        }}
      />
    )
  }
  
  const fetchData = async (select, page = 1) => {
    setIsFetching(true);
    try {
      const {
        data: { data: attendedLoads, meta },
      } = await cooperplaceApi.get(
        `fleet/management/loadAttendeds/${select.id}`,
        {
          params: {
            ...suggestionAdvencedFilters,
            ...fetchOptions,
            page,
            isPreLoad: switchTrackerAttended
          },
        }
      );
      setFetchOptions({
        page: meta.current_page,
        perPage: meta.per_page,
        total: meta.total,
        lastPage: meta.last_page,
      });
      setAttendedSuggestion({ data: attendedLoads, meta });
    } catch (error) {
      setAttendedSuggestion({ data: [] });
      snackbar.show(
        <Text>
          {error?.response?.data?.error ||
            'Erro ao trazer sugestões de cargas'}
        </Text>,
        {
          type: 'error',
        },
      );
    } finally {
      setIsFetching(false);
    }
  };

  const onPageChanged = async (page) => {
    await fetchData(selected, page);
  };

  useEffect(() => {
    if (selected?.id) {
      fetchData(selected);
    }
  }, [selected, switchTrackerAttended, suggestionAdvencedFilters]);

  const formatAddress = (formattedAddress, formatted) => {
    if (
      formattedAddress === null ||
      (typeof formattedAddress === 'string' && formattedAddress?.length === 0)
    ) {
      return formatted;
    }
    return formattedAddress;
  };

  return (
    <>
      <Switch />
      <Divider />
      <div style={{ overflowX: 'auto' }}>
        <Row style={{ minWidth: 1000 }}>
          <Col span={2} className="p-1">
            <Text type="label" weight={500} color="dark">
              Carga
            </Text>
          </Col>
          <Col span={4} className="p-1">
            <Text type="label" weight={500} color="dark">
              Cliente
            </Text>
          </Col>
          <Col span={4} className="p-1">
            <Text type="label" weight={500} color="dark">
              Origem
            </Text>
          </Col>
          <Col span={6} className="p-1">
            <Text type="label" weight={500} color="dark">
              Destinos
            </Text>
          </Col>
          <Col span={4} className="p-1">
            <Text type="label" weight={500} color="dark">
              Produto
            </Text>
          </Col>
          <Col span={4} className="p-1">
            <Text type="label" weight={500} color="dark">
              Base de frete(Tomador)
            </Text>
          </Col>
        </Row>
        {isFetching ? (
          <DefaultLoadingBodyComponent />
        ) : attendedSuggestion.data?.length > 0 ? (
          <>
            <Row className="mt-2" align="middle" style={{ minWidth: 1000 }}>
              {attendedSuggestion.data.map(
                ({
                  id,
                  taker,
                  loadOrigins,
                  loadDestinations,
                  product,
                  takerValue,
                }) => (
                  <React.Fragment key={id}>
                    <Col span={2} className="p-1">
                      <Link to={`/cargas/${id}`}>{id}</Link>
                    </Col>
                    <Col span={4} className="p-1">
                      <Text type="label" weight={500} color="dark">
                        {taker?.label}
                      </Text>
                    </Col>
                    <Col span={4} className="p-1">
                      <Text type="label" weight={500} color="dark">
                        {formatAddress(loadOrigins[0]?.formattedAddress, loadOrigins[0]?.formatted)}
                      </Text>
                    </Col>
                    <Col span={6} className="p-1">
                      <DestinationContainer>
                        {loadDestinations.map(
                          (
                            { formattedAddress, formatted, id: destinationId },
                            index,
                            arr
                          ) => (
                            <React.Fragment key={destinationId}>
                              <Text type="label" weight={500} color="dark">
                                {formatAddress(formattedAddress, formatted)}
                              </Text>
                              {arr.length - 1 !== index && <Divider />}
                            </React.Fragment>
                          )
                        )}
                      </DestinationContainer>
                    </Col>
                    <Col span={4} className="p-1">
                      <Text type="label" weight={500} color="dark">
                        {`${product?.name || 'Sem nome'} - ${product?.ncm || 'Sem NCM'
                          }`}
                      </Text>
                    </Col>
                    <Col span={4} className="p-1">
                      <Text type="label" weight={500} color="dark">
                        {new Intl.NumberFormat('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        }).format(takerValue)}
                      </Text>
                    </Col>
                    <Divider />
                  </React.Fragment>
                )
              )}
            </Row>
            <div className="d-flex align-items-center justify-content-between">
              <Text type="label" color="gray">
                Exibindo {attendedSuggestion?.length} de {fetchOptions.total}{' '}
                registros
              </Text>
              <div>
                <Pagination
                  currentPage={fetchOptions.page}
                  pages={fetchOptions.lastPage}
                  onPageChanged={onPageChanged}
                  ref={paginationRef}
                />
              </div>
            </div>
          </>
        ) : (
          <div className="mt-2 p-1">
            <Text type="label" weight={500} color="dark">
              Sem sugestões de cargas
            </Text>
          </div>
        )}
      </div>
    </>
  );
}

export default AttendedLoads;
